import { Flex } from '@applyboard/crystal-ui';

import { PageHeader } from '../../../components/PageHeader';
import { ProgramFilter, IntakeTermFilter, CampusesFilter, ApplicationStats } from '../components';

export function MobileLayout() {
  return (
    <Flex p={10} gap={3} direction="column">
      <PageHeader title="Reports" />
      <Flex gap={2}>
        <Filter as={<ProgramFilter />} width="100%" />
        <Filter as={<CampusesFilter />} width="100%" />
        <Filter as={<IntakeTermFilter />} width="100%" />
      </Flex>
      <ApplicationStats />
    </Flex>
  );
}

function Filter(props: { as: React.ReactNode; width: string }) {
  return <div style={{ width: props.width }}>{props.as}</div>;
}
